import styled from 'styled-components';
import { Box, spacing, border } from '@landr/maestro';

const KeyControl = styled(Box)`
    width: 424px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ${({ theme }): string => theme.breakpoint('md')`
        height: auto;
        width: auto;    
    `}
    outline: none;
`;

const InputWrapper = styled(Box)`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: ${spacing('lg')};
`;

const Title = styled(Box)`
    height: 24px;
    width: 100%;
    margin: 12px 0;
`;

const KeyWrapper = styled(Box)`
    width: 100%;
    & > * {
        margin-bottom: 8px;
        margin-right: 8px;
    }

    & > :nth-child(1) {
        margin-left: 32px;
    }

    & > :nth-child(3) {
        margin-left: 64px;
    }
    & > :last-child,
    & > :nth-child(2) {
        margin-right: 0;
    }

    ${({ theme }): string => theme.breakpoint('md')`
        align-items: center;
        & > *,
        & > :nth-child(1),
        & > :nth-child(3),
        & > :last-child,
        & > :nth-child(2) {
            margin-top: 0;
            margin-right: ${spacing('md')};
            margin-bottom: ${spacing('md')};
            margin-left: 0;
        } 
    `}

    button {
        width: ${spacing('jb')};
        max-width: ${spacing('jb')};
    }
`;

const Footer = styled(Box)`
    min-height: 64px;
    border-top: ${border('base')};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding: ${spacing('lg')};
`;

export const Styled = {
    KeyControl,
    InputWrapper,
    Title,
    KeyWrapper,
    Footer,
};
